/* ROVIAE product behavior — optimized V26 */

'use strict';

/* ===== Clean product URL ===== */
(function () {
  if (!document.body || document.body.dataset.pageType !== 'product' || window.__roviaeCleanVariantUrlReady) return;
  window.__roviaeCleanVariantUrlReady = true;

  function cleanVariantUrl(input) {
    try {
      var url = new URL(input || window.location.href, window.location.origin);
      if (!url.searchParams.has('variant')) return url.pathname + url.search + url.hash;
      url.searchParams.delete('variant');
      return url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash;
    } catch (error) {
      return input;
    }
  }

  var cleanCurrentUrl = function () {
    var cleanUrl = cleanVariantUrl(window.location.href);
    var currentUrl = window.location.pathname + window.location.search + window.location.hash;
    if (cleanUrl && cleanUrl !== currentUrl) window.history.replaceState(window.history.state, '', cleanUrl);
  };

  cleanCurrentUrl();

  ['replaceState', 'pushState'].forEach(function (methodName) {
    var originalMethod = window.history[methodName];
    if (!originalMethod || originalMethod.__roviaeWrapped) return;
    var wrappedMethod = function (state, title, url) {
      return originalMethod.call(window.history, state, title, url ? cleanVariantUrl(url) : url);
    };
    wrappedMethod.__roviaeWrapped = true;
    window.history[methodName] = wrappedMethod;
  });

  window.addEventListener('popstate', cleanCurrentUrl);
})();

/* ===== Inline video gallery behavior ===== */
(function(){
  if(window.__roviaeVideoModalReady) return;
  window.__roviaeVideoModalReady = true;
  var modal, video, source;
  function build(){
    modal=document.createElement('div');
    modal.className='roviae-video-modal';
    modal.setAttribute('aria-hidden','true');
    modal.innerHTML='<div class="roviae-video-modal__dialog" role="dialog" aria-modal="true" aria-label="Product video"><button class="roviae-video-modal__close" type="button" aria-label="Close video">×</button><video class="roviae-video-modal__video" controls playsinline preload="none"><source type="video/mp4"></video></div>';
    document.body.appendChild(modal);
    video=modal.querySelector('video'); source=modal.querySelector('source');
    modal.addEventListener('click',function(e){if(e.target===modal||e.target.closest('.roviae-video-modal__close')) close();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&modal.classList.contains('is-open')) close();});
  }
  function open(btn){
    if(!modal) build();
    source.src=btn.getAttribute('data-video-src');
    video.poster=btn.getAttribute('data-video-poster')||'';
    video.load();
    modal.classList.add('is-open'); modal.setAttribute('aria-hidden','false');
    document.body.classList.add('roviae-video-modal-open');
    var playPromise=video.play(); if(playPromise&&playPromise.catch) playPromise.catch(function(){});
  }
  function close(){
    if(!modal) return;
    video.pause(); source.removeAttribute('src'); video.removeAttribute('poster'); video.load();
    modal.classList.remove('is-open'); modal.setAttribute('aria-hidden','true');
    document.body.classList.remove('roviae-video-modal-open');
  }
  document.addEventListener('click',function(e){var btn=e.target.closest('[data-roviae-video-open]'); if(btn){e.preventDefault(); open(btn);}});
})();

/* ===== Bundle selector behavior ===== */
(function () {
  window.__rvBundleMemory = window.__rvBundleMemory || {};

  function initializeBundleRoot(root) {
    if (!root || root.dataset.rvStateReady === 'true') return;

    var sectionId = root.dataset.sectionId;
    var productId = root.dataset.productId || 'product';
    if (!sectionId) return;

    root.dataset.rvStateReady = 'true';
    var stateKey = 'rv-bundle-state-v4:' + productId + ':' + sectionId;
    var readState = function () { return window.__rvBundleMemory[stateKey] || {}; };
    var writeState = function (nextState) { window.__rvBundleMemory[stateKey] = nextState; };

    function syncStickyPicker(selected) {
      if (!selected) return;
      var variantId = selected.dataset.variantId;
      var productForm = document.getElementById('product-form-' + sectionId);
      var hiddenVariant = productForm && productForm.querySelector('input[name="id"]');

      if (variantId && hiddenVariant && hiddenVariant.value !== variantId) {
        hiddenVariant.value = variantId;
        hiddenVariant.dispatchEvent(new Event('input', { bubbles: true }));
        hiddenVariant.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (variantId) {
        document.dispatchEvent(new CustomEvent('rv:bundle-variant-change', {
          detail: { sectionId: sectionId, variantId: String(variantId), title: selected.value }
        }));
      }

      var picker = document.getElementById('StickyAtcVariantPicker-' + sectionId);
      var select = picker && picker.querySelector('.sticky-atc__variant-select');
      if (!select) return;

      var matchingOption = Array.prototype.slice.call(select.options).find(function (option) {
        var optionValues = (option.dataset.options || '').split(',').map(function (item) { return item.trim(); });
        return (variantId && option.dataset.variantId === variantId)
          || optionValues.indexOf(selected.value) !== -1
          || option.textContent.trim() === selected.value;
      });

      if (matchingOption && select.selectedIndex !== matchingOption.index) {
        select.selectedIndex = matchingOption.index;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    var inputs = Array.prototype.slice.call(root.querySelectorAll('.rv-bundle__input'));
    var upgrade = root.querySelector('[data-rv-upgrade]');
    var state = readState();
    var hasVariantInUrl = new URLSearchParams(window.location.search).has('variant');
    var initialSelected = null;

    if (state.interacted === true && state.selectedValue) {
      var rememberedInput = inputs.find(function (input) { return input.value === state.selectedValue && !input.disabled; });
      if (rememberedInput) {
        rememberedInput.checked = true;
        initialSelected = rememberedInput;
      }
    }

    if (state.interacted !== true && state.defaultApplied !== true && !hasVariantInUrl) {
      var fivePack = inputs.find(function (input) { return input.value === '5 Bricks' && !input.disabled; });
      if (fivePack) {
        inputs.forEach(function (input) { input.checked = input === fivePack; });
        initialSelected = fivePack;
        state.selectedValue = '5 Bricks';
      }
      state.defaultApplied = true;
    }

    if (typeof state.interacted !== 'boolean') state.interacted = false;
    if (typeof state.defaultApplied !== 'boolean') state.defaultApplied = false;
    writeState(state);

    function sync(selected, shouldSyncVariant, fromUser) {
      if (!selected) return;
      if (upgrade) upgrade.hidden = selected.value !== '5 Bricks';

      if (fromUser) {
        var current = readState();
        current.interacted = true;
        current.selectedValue = selected.value;
        writeState(current);
      }

      if (shouldSyncVariant) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { syncStickyPicker(selected); });
        });
      }
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) sync(input, true, true);
      });
    });

    if (upgrade) {
      upgrade.addEventListener('click', function () {
        var ten = inputs.find(function (input) { return input.value === '10 Bricks' && !input.disabled; });
        if (ten) ten.click();
      });
    }

    var selectedOnInit = initialSelected || inputs.find(function (input) { return input.checked; });
    var shouldApplyFiveDefault = selectedOnInit && selectedOnInit.value === '5 Bricks' && !hasVariantInUrl && state.interacted !== true;
    sync(selectedOnInit, shouldApplyFiveDefault, false);
  }

  function initBundles(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-rv-bundle]')) initializeBundleRoot(context);
    if (context.querySelectorAll) {
      context.querySelectorAll('[data-rv-bundle]').forEach(initializeBundleRoot);
    }
  }

  function start() {
    initBundles(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', function (event) { initBundles(event.target); });
})();

/* ===== Product CRO behavior — roviae_product_specs ===== */
(function(){
  function closeInner(root){
    root.querySelectorAll('.roviae-product-details__item[open]').forEach(function(item){ item.open=false; });
  }
  function initRoviaeNested(root){
    if(!root || root.dataset.initialized==='true') return;
    root.dataset.initialized='true';
    var outer=root.querySelector('[data-roviae-product-details]');
    var inner=root.querySelector('[data-roviae-inner-accordion]');
    if(!outer || !inner) return;
    var items=Array.prototype.slice.call(inner.querySelectorAll('.roviae-product-details__item'));
    items.forEach(function(item){
      item.addEventListener('toggle',function(){
        if(!item.open) return;
        items.forEach(function(other){ if(other!==item && other.open) other.open=false; });
      });
    });
    outer.addEventListener('toggle',function(){ if(!outer.open) closeInner(root); });
    document.addEventListener('click',function(event){
      if(root.contains(event.target)) return;
      outer.open=false;
      closeInner(root);
    });
    document.addEventListener('keydown',function(event){
      if(event.key==='Escape'){ outer.open=false; closeInner(root); }
    });
    if('IntersectionObserver' in window){
      var observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){ if(!entry.isIntersecting){ outer.open=false; closeInner(root); } });
      },{threshold:0});
      observer.observe(root);
    }
  }
  document.querySelectorAll('.roviae-product-details--nested').forEach(initRoviaeNested);
  document.addEventListener('shopify:section:load',function(event){
    event.target.querySelectorAll('.roviae-product-details--nested').forEach(initRoviaeNested);
  });
})();

/* ===== Sticky ATC / bundle sync ===== */
(function () {
  function initializeStickyAtc(stickyAtc) {
    if (!stickyAtc) return;
    var sectionId = stickyAtc.dataset.section;
    if (!sectionId) return;

    var picker = document.getElementById('StickyAtcVariantPicker-' + sectionId);
    var stickySelect = picker && picker.querySelector('.sticky-atc__variant-select');
    var stickyButton = document.getElementById('SectionAtcBtn-' + sectionId);
    var mainButton = document.getElementById('ProductSubmitButton-' + sectionId);
    var productForm = document.getElementById('product-form-' + sectionId);
    var hiddenVariant = productForm && productForm.querySelector('input[name="id"]');
    var variantsNode = picker && picker.querySelector('script[type="application/json"]');
    if (!stickySelect || !stickyButton || !variantsNode || stickyButton.dataset.rvDirectReady === 'true') return;
    stickyButton.dataset.rvDirectReady = 'true';

    var variants = [];
    try { variants = JSON.parse(variantsNode.textContent); } catch (error) { return; }

    function money(cents) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);
    }

    function selectedBundle() {
      return document.querySelector('[data-rv-bundle][data-section-id="' + sectionId + '"] .rv-bundle__input:checked');
    }

    function variantById(id) {
      return variants.find(function (variant) { return String(variant.id) === String(id); });
    }

    function updatePurchaseUi(variant) {
      if (!variant) return;

      var formattedPrice = money(variant.price);
      var available = variant.available !== false;

      // Sticky price block.
      var root = document.getElementById('sticky-atc-separate-price-' + sectionId);
      if (root) {
        var price = root.querySelector('.price');
        var regular = root.querySelector('.price__regular .price-item--regular');
        var sale = root.querySelector('.price-item--sale');
        var compare = root.querySelector('.price__compare-price .price-item--regular');
        var badge = root.querySelector('.price__badge-sale .nowrap');
        if (regular) regular.textContent = formattedPrice;
        if (sale) sale.textContent = formattedPrice;
        var onSale = Number(variant.compare_at_price) > Number(variant.price);
        if (price) price.classList.toggle('price--on-sale', onSale);
        if (compare) compare.textContent = onSale ? money(variant.compare_at_price) : '';
        if (badge) {
          var pct = onSale ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
          badge.textContent = onSale ? 'SAVE ' + pct + '%' : '';
        }
      }

      // Sticky ATC button price/title/availability.
      var stickyButtonPrice = document.getElementById('sticky-atc-price-' + sectionId);
      if (stickyButtonPrice) stickyButtonPrice.textContent = formattedPrice;
      if (stickyButton) {
        stickyButton.disabled = !available;
        var stickyLabel = stickyButton.querySelector('.sticky-atc__label__text');
        if (stickyLabel) stickyLabel.textContent = available ? 'Add to cart' : 'Sold out';
        var stickyDivider = stickyButton.querySelector('.sticky-atc__label__divider');
        if (stickyDivider) stickyDivider.classList.toggle('hidden', !available);
        if (stickyButtonPrice) stickyButtonPrice.classList.toggle('hidden', !available);
      }

      // Main ATC button price/availability. This is what was previously left at the 1-Brick price.
      var mainButton = document.getElementById('ProductSubmitButton-' + sectionId);
      var mainButtonPrice = document.getElementById('main-atc-price-' + sectionId);
      if (mainButtonPrice) mainButtonPrice.textContent = formattedPrice;
      if (mainButton) {
        mainButton.disabled = !available;
        if (available) mainButton.removeAttribute('data-unavailable');
        else mainButton.setAttribute('data-unavailable', 'true');
        var mainLabel = mainButton.querySelector('.main-atc__label__text');
        if (mainLabel) mainLabel.textContent = available ? 'Add to cart' : 'Sold out';
        var mainDivider = mainButton.querySelector('.main-atc__divider');
        if (mainDivider) mainDivider.classList.toggle('hidden', !available);
        if (mainButtonPrice) mainButtonPrice.classList.toggle('hidden', !available);
      }
    }

    function applyVariant(variantId) {
      var variant = variantById(variantId);
      if (!variant) return null;
      var option = Array.prototype.slice.call(stickySelect.options).find(function (item) {
        return String(item.dataset.variantId) === String(variant.id);
      });
      if (option) stickySelect.selectedIndex = option.index;
      if (hiddenVariant) {
        hiddenVariant.value = String(variant.id);
        hiddenVariant.dispatchEvent(new Event('input', { bubbles: true }));
        hiddenVariant.dispatchEvent(new Event('change', { bubbles: true }));
      }
      updatePurchaseUi(variant);
      var stickyTitle = document.getElementById('sticky-atc-title-' + sectionId);
      if (stickyTitle) stickyTitle.textContent = variant.title;
      return variant;
    }

    function currentBundleVariant() {
      var bundle = selectedBundle();
      var id = bundle && bundle.dataset.variantId;
      var selectedOption = stickySelect.options[stickySelect.selectedIndex];
      return applyVariant(id || (selectedOption && selectedOption.dataset.variantId));
    }

    stickySelect.addEventListener('change', function () {
      var option = stickySelect.options[stickySelect.selectedIndex];
      applyVariant(option && option.dataset.variantId);
    });

    document.addEventListener('rv:bundle-variant-change', function (event) {
      var detail = event.detail || {};
      if (String(detail.sectionId) !== String(sectionId) || !detail.variantId) return;
      applyVariant(detail.variantId);
    });

    if (mainButton) {
      mainButton.addEventListener('click', function () {
        // Last-moment guard: cart submission must always use the checked bundle variant.
        currentBundleVariant();
      }, true);
    }

    stickyButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var variant = currentBundleVariant();
      if (!variant || !variant.available || !productForm) return;

      var nativeSubmit = productForm.querySelector('button[type="submit"][name="add"], button[type="submit"].product-form__submit');
      if (nativeSubmit && !nativeSubmit.disabled) nativeSubmit.click();
      else if (typeof productForm.requestSubmit === 'function') productForm.requestSubmit();
    }, true);

    requestAnimationFrame(currentBundleVariant);
  }

  function initStickyAtc(scope) {
    var context = scope || document;
    if (context.matches && context.matches('sticky-atc[data-section]')) initializeStickyAtc(context);
    if (context.querySelectorAll) context.querySelectorAll('sticky-atc[data-section]').forEach(initializeStickyAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initStickyAtc(document); }, { once: true });
  } else {
    initStickyAtc(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initStickyAtc(event.target); });
})();
